"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaytimeType = exports.ProductType = exports.DispensingCategory = exports.Availability = exports.AvailabilityType = void 0;
var AvailabilityType;
(function (AvailabilityType) {
    AvailabilityType[AvailabilityType["green"] = 0] = "green";
    AvailabilityType[AvailabilityType["orange"] = 1] = "orange";
    AvailabilityType[AvailabilityType["red"] = 2] = "red";
    AvailabilityType[AvailabilityType["black"] = 3] = "black";
    AvailabilityType[AvailabilityType["gray"] = 4] = "gray";
})(AvailabilityType || (exports.AvailabilityType = AvailabilityType = {}));
var Availability;
(function (Availability) {
    Availability[Availability["AvailableImmediately"] = 0] = "AvailableImmediately";
    Availability[Availability["FirstWorkingDaysRange"] = 1] = "FirstWorkingDaysRange";
    Availability[Availability["SecondWorkingDaysRange"] = 2] = "SecondWorkingDaysRange";
    Availability[Availability["ThirdWorkingDaysRange"] = 3] = "ThirdWorkingDaysRange";
    Availability[Availability["LastWorkingDaysRange"] = 4] = "LastWorkingDaysRange";
    Availability[Availability["PharmaCodeNotFound"] = 5] = "PharmaCodeNotFound";
    Availability[Availability["UnknownDates"] = 6] = "UnknownDates";
    Availability[Availability["OutOfTrade"] = 7] = "OutOfTrade";
})(Availability || (exports.Availability = Availability = {}));
var DispensingCategory;
(function (DispensingCategory) {
    DispensingCategory["D"] = "D";
})(DispensingCategory || (exports.DispensingCategory = DispensingCategory = {}));
var ProductType;
(function (ProductType) {
    ProductType["Original"] = "original";
    ProductType["Generic"] = "generic";
})(ProductType || (exports.ProductType = ProductType = {}));
var DaytimeType;
(function (DaytimeType) {
    DaytimeType["morning"] = "morning";
    DaytimeType["midday"] = "midday";
    DaytimeType["evening"] = "evening";
    DaytimeType["night"] = "night";
})(DaytimeType || (exports.DaytimeType = DaytimeType = {}));
//# sourceMappingURL=product.js.map